import { Login } from 'react-admin'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import LoginForm from './LoginForm'
import appLogo from '../../assets/logo_lgs.png'

const useStyles = makeStyles({
  wrapper: {
    '& .RaLogin-main': {
      background:
        'linear-gradient(160deg, #042f2e 0%, #0f766e 35%, #115e59 70%, #0f172a 100%)',
    },
    '& .RaLogin-card': {
      borderRadius: 24,
      minWidth: 440,
      maxWidth: 440,
      paddingTop: 0,
      border: '1px solid rgba(255,255,255,0.1)',
      boxShadow: '0 32px 64px rgba(0,0,0,0.4)',
      overflow: 'hidden',
    },
    '& .RaLogin-avatar': {
      display: 'none',
    },
    '& .RaLogin-icon': {
      display: 'none',
    },
  },
  brand: {
    textAlign: 'center',
    padding: '32px 32px 16px',
    background: 'linear-gradient(180deg, #f0fdfa 0%, #ffffff 100%)',
    margin: '-8px -8px 0',
  },
  logo: {
    maxWidth: 150,
    marginBottom: 8,
  },
  tagline: {
    color: '#64748b',
    fontSize: 14,
  },
})

const LoginPage = () => {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      <Login>
        <Box className={classes.brand}>
          <img src={appLogo} alt="Let's Go Surveys" className={classes.logo} />
          <Typography className={classes.tagline}>Admin Panel</Typography>
        </Box>
        <LoginForm />
      </Login>
    </div>
  )
}

export default LoginPage
